import { AxiosError } from 'axios';
import { queryCache, QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import {
  loadArchiveSettings,
  LoadArchiveSettingsResponse,
} from '~src/services/api/archiveSettings';
import { useProjectId } from '../useProjectId';
import { getGroups, RegistrationLabel } from '~src/services/api/labels';
import { useEffect } from 'react';

export const useRegistrationLabelGroups = (
  show_deleted: boolean,
  queryConfig: QueryConfig<RegistrationLabel[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  useEffect(() => {
    queryCache.invalidateQueries('registrationLabelGroups');
  }, [show_deleted]);

  const projectId = useProjectId();
  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const registrationLabelGroups = useQuery<RegistrationLabel[], AxiosError>(
    ['registrationLabelGroups', { projectId, show_deleted }],
    getGroups,
    {
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return registrationLabelGroups;
};
